<style scoped>
.fixed-full {
  background: rgba(24, 24, 27, 0.98) !important;
}

.q-card {
  padding: 20px 0px !important;
  border-radius: 30px !important;
}

.radio-text {
  font-size: 14px !important;
}

.input-wrap {
  align-items: center;
}

input[type="date"]::placeholder {
  color: #999;
  /* Цвет плейсхолдера */
}

.q-avatar {
  width: 16px !important;
  top: -6px;
}

.phone-input .q-avatar {
  width: 14px !important;
}

.q-field--standout.q-field--highlighted .q-field__control {
  background: #f5f5f5 !important;
  box-shadow: none !important;
}

.q-field__label {
  color: #6d6d6d !important;
  font-weight: 400 !important;
  top: 11px !important;
}

.q-field--standout.q-field--highlighted .q-field__input {
  color: #6d6d6d !important;
}

.q-select .q-field__input,
.inputSum .q-field__native,
.q-field__native, .q-field__input  {
  font-size: 16px;
  transform: scale(0.7);
  transform-origin: left top;
  margin-top: 5px;
}

::v-deep(.material-icons) {
  position: absolute;
  right: 5%;
  top: 20%;
}

.material-icons {
  top: -5px;
}

::v-deep(.q-spinner) {
  position: absolute;
  right: 5%;
  margin-top: -10px;
}

.q-field--standout.q-field--highlighted .q-field__native {
  color: #6d6d6d !important;
}

.phone-input .q-field__label {
  top: 10px !important;
}

.q-checkbox__inner--truthy .q-checkbox__bg {
  background: #ed885c !important;
}

.q-checkbox__bg {
  border: 2px solid #ed885c !important;
}

.q-field--auto-height .q-field__native {
  min-height: 30px !important;
}

.q-field--with-bottom {
  margin-bottom: 5px !important;
}

.q-field__bottom--animated {
  bottom: -10px !important;
}
</style>
<style scoped>
/*slider*/

.min,
.max {
  display: none;
}

.text {
  color: #040404;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.slider-ui {
  position: relative;
  width: 210px;
  height: 40px;
}

.slider-ui input {
  position: absolute;
  z-index: 10;
  top: 0;
  bottom: 0;
  width: 100%;
  cursor: pointer;
  opacity: 0;
}

.slider-ui .bar {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  border-radius: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-ui .min,
.slider-ui .max {
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 800;
  color: #fff;
}

.slider-ui .min {
  left: 2%;
}

.slider-ui .max {
  right: 2%;
}

.slider-ui .track {
  position: absolute;
  z-index: 3;
  left: 25px;
  right: 25px;
  top: 0;
  bottom: 0;
}

.slider-ui .value {
  position: absolute;
  left: 50%;
  top: 18%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  background-color: #ed885c;
  border: 4px solid #000;
  border-radius: 100%;
  box-sizing: border-box;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out, color 0.3s ease-in-out;
}

.slider-ui .value.up {
  top: -110%;
  color: #000;
}

.slider-ui.color1 .bar {
  background-color: #f5f5f5;
}

.slider-ui.color2 .bar {
  background-color: #f5f5f5;
}

.slider-ui.color1 .value {
  border-color: #ed885c;
  transition: all 0.3s ease-in-out;
}

.slider-ui.color2 .value {
  border-color: #ed885c;
  transition: all 0.3s ease-in-out;
}

.sum-wrapper,
.days-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.slider-display {
  background: #f5f5f5;
  border-radius: 56px;
  width: 80px;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-value {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: #000;
}

.slider-value-2 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  padding-left: 15px;
}

.currency {
  color: #767676;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}

.info-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
}

.consent-text {
  width: 90%;
}

.form-button__second {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border-radius: 10px;
  background: #ed885c;
  border: 1px solid #ed885c;
  padding: 10px 15px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

}

.form-button__second:hover {
  background: transparent;
  color: #ed885c;
}

.form-button__wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
}

.passport-wrapper {
  display: flex;
  justify-content: space-between;
}

.passport-wrapper q-input {
  width: 45%;
}

.q-field--standout.q-field--rounded .q-field__control {
  border: 1px solid transparent;
}

.q-field--error.q-field--standout.q-field--rounded .q-field__control {
  border: 1px solid #c10015;
}

.passport-wrapper .q-field {
  width: 48%;
}

.issue-date .q-field {
  width: 100% !important;
}

.continue-text {
  color: #000;
  font-size: 8px;
  font-style: normal;
  font-weight: 300;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-align: center;
  margin-top: 15px;
  cursor: pointer;
}
</style>
<style scoped>
.step-two__title {
  color: #000;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: 50px;
  margin-bottom: 30px;
}

.title-step__two {
  color: #000;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;

  margin-bottom: 30px;
}

.anketa-wrap {
  padding: 40px 80px 30px 70px;
}

.label-issue {
  display: none;
}

.label-dob {
  display: none;
}

.issue-date {
  position: relative;
  width: 48%;
}

.label-issue {
  position: absolute;
  top: 20%;
  left: 20%;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1;
  pointer-events: none;
  /* Чтобы label не блокировал клики на input */
}

.label-focused {
  opacity: 0;
  transform: translateY(-10px);
  /* Немного сдвигаем label, чтобы он ушел */
}

q-input {
  position: relative;
  z-index: 2;
  /* Убедимся, что input находится выше label */
}

.label-issue,
.label-dob {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
}

.dob-date {
  position: relative;
  width: 100%;
}

.label-dob {
  position: absolute;
  top: 18%;
  left: 35%;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1;
  pointer-events: none;
  /* Чтобы label не блокировал клики на input */
}

.label-focused {
  opacity: 0;
  transform: translateY(-10px);
  /* Немного сдвигаем label, чтобы он ушел */
}

q-input {
  position: relative;
  z-index: 2;
  /* Убедимся, что input находится выше label */
}

.input-req input {
  text-align: center;
  /* Центрируем текст */
  padding: 0;
  /* Убираем лишние отступы */
  appearance: none;
  /* Сбрасываем нативный стиль */
  -webkit-appearance: none;
  /* Для Safari */
  -moz-appearance: none;
  /* Для Firefox */
}

.input-req {
  display: flex;
  align-items: center;
  justify-content: center;
  /* Центрируем текст */
}

.input-req input[type="date"]::-webkit-inner-spin-button,
.input-req input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  /* Убираем стрелки и иконки, которые могут сбивать форматирование */
}

.input-req input[type="date"] {
  line-height: 1.5;
  /* Убедитесь, что значение не сжимается */
  text-align: center;
  /* Центрируем текст вручную */
}
</style>
<style>
.q-radio__bg path {
  color: #ed885c !important;
}

.error-message {
  color: #c10015;
  transition: all 0.3s ease-in-out;
  font-size: 12px;
}

@media (max-width: 500px) {
  .form-button__second {
    width: 60% !important;
  }

  .label-issue,
  .label-dob {
    display: block !important;
  }

  .step-two__title {
    font-size: 16px;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .title-step__two {
    font-size: 16px;

    margin-bottom: 20px;
  }

  .anketa-wrap {
    padding: 20px 10px !important;
  }
}
</style>













<style>
a {
  cursor: pointer;
}

.q-avatar {
  width: 16px !important;
  top: -6px;
}

.phone-input .q-avatar {
  width: 14px !important;
}

.q-field--standout.q-field--highlighted .q-field__control {
  background: #f5f5f5 !important;
  box-shadow: none !important;
}
.q-field__native {
  padding: 0px 0px 0px 15px !important;
 
}

.phone .q-field__native {
  font-size: 16px;
  transform: scale(0.75);
  transform-origin: left top;
  margin-top: 8px;
}

.q-field__label {
  color: #6d6d6d !important;
  font-weight: 400 !important;
  top: 11px !important;
}

.q-field--standout.q-field--highlighted .q-field__input {
  color: #6d6d6d !important;
}

.q-select .q-field__input,
.inputSum .q-field__native,
.q-field__native, .q-field__input {
  font-size: 16px;
  transform: scale(0.75);
  transform-origin: left top;
  margin-top: 5px;
}

.q-field--auto-height .q-field__control {
  height: 40px !important;
  min-height: 40px !important;
}

.q-field--standout.q-field--rounded .q-field__control {
  height: 40px !important;
  min-height: 40px !important;
}

.material-icons {
  font-size: 0px !important;
}

.q-spinner {
  margin-top: -10px;
}

.q-field--standout.q-field--highlighted .q-field__native {
  color: #6d6d6d !important;
}

.phone-input .q-field__label {
  top: 10px !important;
}

.q-checkbox__inner--truthy .q-checkbox__bg {
  background: #ed885c !important;
}

.q-checkbox__bg {
  border: 2px solid #ed885c !important;
}

.q-field--auto-height .q-field__native {
  min-height: 30px !important;
}

.q-field--with-bottom {
  margin-bottom: 5px !important;
}

.q-field__bottom--animated {
  bottom: -10px !important;
}

.q-checkbox__bg {
  top: -50% !important;
}

@media (max-width: 768px) {
  .q-checkbox__bg {
    top: 0% !important;
  }
}

@media (max-width: 441px) {
  .q-checkbox__bg {
    top: -30% !important;
  }
}

@media (max-width: 400px) {
  .q-checkbox__bg {
    top: -50% !important;
  }
}
</style>
<style scoped>
.text-primary {
  color: #ed885c !important;
}

.anketa-wrap {
  margin: 0 auto;
  padding: 0;
}

@media (max-width: 450px) {
  .anketa-wrap {
    padding: 0;
  }
}

/*slider*/

.min,
.max {
  display: none;
}

.text {
  color: #040404;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
}

.slider-ui {
  position: relative;
  width: 210px;
  height: 40px;
}

.slider-ui input {
  position: absolute;
  z-index: 10;
  top: 0;
  bottom: 0;
  width: 100%;
  cursor: pointer;
  opacity: 0;
}

.slider-ui .bar {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  border-radius: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-ui .min,
.slider-ui .max {
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 800;
  color: #fff;
}

.slider-ui .min {
  left: 2%;
}

.slider-ui .max {
  right: 2%;
}

.slider-ui .track {
  position: absolute;
  z-index: 3;
  left: 25px;
  right: 25px;
  top: 0;
  bottom: 0;
}

.slider-ui .value {
  position: absolute;
  left: 50%;
  top: 18%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  background-color: #ed885c;
  border: 4px solid #000;
  border-radius: 100%;
  box-sizing: border-box;
  transform: translateX(-50%);
  transition: top 0.3s ease-in-out, color 0.3s ease-in-out;
}

.slider-ui .value.up {
  top: -110%;
  color: #000;
}

.slider-ui.color1 .bar {
  background-color: #f5f5f5;
}

.slider-ui.color2 .bar {
  background-color: #f5f5f5;
}

.slider-ui.color1 .value {
  border-color: #ed885c;
  transition: all 0.3s ease-in-out;
}

.slider-ui.color2 .value {
  border-color: #ed885c;
  transition: all 0.3s ease-in-out;
}

.sum-wrapper,
.days-wrapper {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
}

.slider-display {
  background: #f5f5f5;
  border-radius: 56px;
  width: 80px;
  padding: 9px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-value {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: #000;
}

.slider-value-2 {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: #000;
  padding-left: 15px;
}

.docs-wrapper {
  margin-top: 18px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.currency {
  color: #767676;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}

.info-wrapper {
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 20px;
}

.info-wrapper img {
  margin-top: 5px;
}

.consent-text {
  width: 90%;
}

.form-button {
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  border-radius: 10px;
  background: #ed885c;
  border: 1px solid #ed885c;
  padding: 10px 15px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}

.form-button:hover {
  background: transparent;
  color: #ed885c;
}

.anketa-wrap {
  margin: 0 auto;
  padding: 0 !important;
}

::v-deep(.q-checkbox__bg) {
  top: 25% !important;
}

::v-deep(.docs-wrapper) {
  margin-top: 0 !important;
}

::v-deep(.form-button__second) {
  width: 50%;
  font-size: 13px !important;
  padding: 12px 24px;
}

::v-deep(.form-button__wrapper) {
  margin-bottom: 15px;
}

.calculator-wrapper {
  align-items: normal;
  background: #fff;
  border-radius: 20px;
  width: 100%;
  padding: 20px 80px;
}
</style>
<style lang="scss">
.second-step .q-select .q-field__input {
  text-align: center !important;
  margin-left: 65px !important;
}

.second-step {
  .q-field__native {
    text-align: center !important;
  }
}

.second-step {
  .q-field__control-container {
    font-size: 12px !important;
  }
}

.second-step .q-field--standout.q-field--highlighted .q-field__input {
  text-align: center !important;
}

.second-step .q-field--standout.q-field--highlighted .q-field__native {
  text-align: center !important;
}

.form-wrapper {
  width: 100%;
}

.q-dialog__inner>.q-card>.q-card__actions .q-btn--rectangle {
  background: #ed885c !important;
  border: 1px solid #ed885c !important;
  color: #fff !important;
  padding: 10px 15px !important;
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border-radius: 10px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
}

.q-dialog__inner>.q-card>.q-card__actions .q-btn--rectangle:hover {
  background: transparent;
  border: 1px solid #ed885c !important;
}

.q-select .q-field__input {
  min-width: 250px !important;
}

@media (max-width: 768px) {
  .info-wrapper {
    justify-content: normal;
  }

  .info-text {
    margin-left: 12px;
  }

  .second-step .q-select .q-field__input {
    margin-left: 50px !important;
  }
}


.is-invalid .q-checkbox__bg{
  border: 2px solid #C10015;
}
.docs-wrapper .is-invalid-text{
  color: #C10015;
}
.is-invalid-text a{
  color: #C10015;
}
.docs-wrapper a{
  text-decoration: underline;
}

</style>

<template>
  <div class="calculator-wrapper">
    <!-- <div class="main-block__text">Отправьте заявку</div> -->


    <div class="form-wrapper">
      <q-input :color="themeColor" type="number" class="inputSum" ref="inputSum" :rules="sumValidate" v-model="form.amount" rounded
        standout placeholder="Сумма">

      </q-input>
      <q-select :color="themeColor" :rules="fioValidate" v-model="form.fio" use-input rounded standout hide-selected
        fill-input input-debounce="0" placeholder="ФИО" class="input-req" :options="FioSuggestOptions"
        @filter="fetchFio" ref="inputFio" new-value-mode="add" behavior="menu">

      </q-select>
      <q-input :rules="phoneValidate" rounded standout ref="inputPhone" v-model="form.phone"
        class="input-req input phone" @focus="handleFocus" @click="handleFocus" placeholder="Телефон"
        mask="+7 (###) ###-####">

      </q-input>
      <div class="docs-wrapper">
        <q-checkbox ref="consentCheckbox" @click="removeClass" v-model="form.consent" />
        <div class="consent-text" ref="consentText" v-html="getConsentText()"></div>
      </div>


      <div class="form-button__wrapper">
        <button class="form-button__second" @click="nextStep()">Отправить заявку</button>
      </div>

    </div>
  </div>
</template>

<script>
import { debounce } from "debounce";
import * as Bid from "@/assets/js/bid/pts_create.js";
import * as Validate from "@/assets/js/validators.js";
import * as Goal from "@/assets/js/goal.js";
import * as DataParams from "@/assets/js/data_params.js";
import * as Suggest from "@/assets/js/suggest.js";
export default {
  name: "FormPTSAutozalog.vue",

  props: {
    formType: String,
    forwardPage: Function,
    backwardPage: Function,
  },

  data: () => ({
    sendPromise: Promise.resolve(),
    firstnameSuggestOptions: [],
    lastnameSuggestOptions: [],
    secondnameSuggestOptions: [],
    FioSuggestOptions: [],
    consentTextDefault:
      'Даю свое согласие на <a href="/docs/Soglasie_na_obrabotku_personalnyh_dannyh.pdf" target="_blank">обработку персональных данных</a>, на <a href="/docs/Soglasie_na_poluchenie_reklamnyh_materialov.pdf" target="_blank">получение</a> рекламных материалов. Соглашаюсь с условиями <a href="/docs/Oferta.pdf" target="_blank">оферты</a>. Я принял соглашение на оформление <a href="/docs/Prilozhenie_4_Soglashenie_na_oformlenie_platnoj_podpiski.pdf" target="_blank">платной подписки</a>. Для активации сервиса будет списан 1 рубль, дальнейшее использование сервиса будет проходит в соответствии с <a href="/docs/Prilozhenie_2_Informacija_o_dejstvujushhih_tarifah.pdf" target="_blank">тарифами сервиса</a>. Стоимость услуги четыреста девяносто восемь рублей каждые 5 дней по подписке. Подписка не гарантирует получение займа!',
    isNextClicked: false,
    sendPromise: Promise.resolve(),
    form: {
      phone: null,
      fio: null,
      debt: null,
      property: null,

    },
    error: null,

    valid: {
      fio: true,
      phone: true,
      sum: true,
      consent: true,
    },
    themeColor: DataParams.get("color"),
  }),

  computed: {
    //validation
    phoneValidate() {
      return [
        (val) => (val !== null && val !== "") || "Введите телефон",
        (val) => Validate.phone(val) || "Введите полностью",
      ];
    },
    sumValidate() {
      return [
        (val) => (val !== null && val !== "") || "Введите сумму",
        (val) => (val >= 50000 && val <= 5000000) || "Сумма должна быть от 50 000 до 1 000 000",
      ];
    },

    fioValidate() {
      return [
        (val) => (val !== null && val !== "") || "Введите ФИО",
        (val) => Validate.textOnly(val) || "Введите корректно",
      ];
    },
  },

  methods: {
    handleFocus() {
      if (!this.form.phone) {
        this.form.phone = "9"; // Устанавливаем 9, чтобы маска отобразилась
      }
      this.$nextTick(() => {
        const input = this.$refs.inputPhone?.$el?.querySelector("input");
        if (input) {
          requestAnimationFrame(() => {
            input.setSelectionRange(input.value.length, input.value.length);
          });
        }
      });
    },
    getConsentText() {
      return window.consent || this.consentTextDefault;
    },
    //Нажатие на кнопку "продолжить"

    //Валидация формы

    async nextStep() {

      const isValidFio = this.$refs.inputFio.validate();
      const isValidSum = this.$refs.inputSum.validate();
      const isValidPhone = await this.$refs.inputPhone.validate();
      const consent = this.$refs.consentCheckbox.$el;
      const consentText = this.$refs.consentText;
    if (!this.form.consent) {
        consent.classList.add("is-invalid");
        consentText.classList.add("is-invalid-text");
        return true;
      }

      if (!isValidPhone || !isValidFio || !isValidSum) {
        return true;
      }
      Bid.send(this.form);
       this.forwardPage();
    },
    fetchLastname: debounce(function (search, update) {
      if (!search.length) {
        () => (this.lastnameSuggestOptions = [search]);
        return;
      }
      this.fetchFioSuggest(search, update, "surname");
    }, 500),

    fetchFirstname: debounce(function (search, update) {
      if (!search.length) {
        () => (this.firstnameSuggestOptions = [search]);
        return;
      }
      this.fetchFioSuggest(search, update, "name");
    }, 500),

    fetchSecondname: debounce(function (search, update) {
      if (!search.length) {
        () => (this.secondnameSuggestOptions = [search]);
        return;
      }
      this.fetchFioSuggest(search, update, "patronymic");
    }, 500),

    fetchFio: debounce(function (search, update) {
      if (!search.length) {
        () => (this.lastnameSuggestOptions = [search]);
        return;
      }
      this.fetchFioSuggest(search, update, "fio");
    }, 500),
    fetchFioSuggest(search, update, type) {
      Suggest.suggestFioFull(search, type)
        .then((data) => {
          update(() => {
            this.FioSuggestOptions = data.map((el) => el.text);
          });
        })
        .catch(() => {
          update(() => {
            this.FioSuggestOptions = [search];
          });
        });
    },
  },
  watch: {

  },
};
</script>
